(($, Drupal) => {
  Drupal.behaviors.readMoreBckgndBrushSlider = {
    attach: function attch(context) {
      addSlider($('.js-readmore-bckgnd-slider'));
      $(window).resize(() => {
        addSlider($('.js-readmore-bckgnd-slider'));
      });
      function addSlider(element) {
        if (window.matchMedia('(max-width: 1024px)').matches) {
          if (!$(element).hasClass('slick-slider')) {
            $(element).slick({
              arrows: false,
              dots: true,
              autoplay: true,
              draggable: true,
              speed: 1000,
              mobileFirst: true,
              slidesToShow: 1,
              variableWidth: true,
            });
          }
        } else if ($(element).hasClass('slick-slider')) {
          $(element).slick('unslick');
        }
      }
    },
  };
})(jQuery, Drupal);
